import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Employee  {
    _originalTypeClassName = "zSHR.BO.Employee";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Employee.translate = translateService;
}
this.Address = new Domain.Address();
this.Id = null;
this.Code = null;
this.FirstName = null;
this.LastName = null;
this.FatherName = null;
this.FatherSurname = null;
this.MotherName = null;
this.MotherSurname = null;
this.Fullname = null;
this.DateOfBirth = null;
this.PlaceOfBirth = null;
this.Gender = null;
this.FamilyStatus = null;
this.SpouseName = null;
this.ChildrenCount = null;
this.PhoneNumber = null;
this.MobilePhoneNumber = null;
this.Email = null;
this.DocumentId = null;
this.DocumentAuthority = null;
this.DocumentIssueDate = null;
this.DocumentExpirationDate = null;
this.PassportId = null;
this.IBAN = null;
this.TaxNumber = null;
this.SocialSecurityNumber = null;
this.SocialRegistryNumber = null;
this.SecondarySocialRegistryNumber = null;
this.FirstInsuranceDate = null;
this.UnemploymentCardNumber = null;
this.HasUnemploymentBenefit = false;
this.WorkExperience = null;
this.WorkExperienceMonths = null;
this.WorkExperienceDays = null;
this.BusinessPhone = null;
this.InternalPhone = null;
this.EmailBusiness = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
FirstName:any;
LastName:any;
FatherName:any;
FatherSurname:any;
MotherName:any;
MotherSurname:any;
Fullname:any;
DateOfBirth:any;
PlaceOfBirth:any;
Gender:any;
FamilyStatus:any;
SpouseName:any;
ChildrenCount:any;
PhoneNumber:any;
MobilePhoneNumber:any;
Email:any;
DocumentId:any;
DocumentAuthority:any;
DocumentIssueDate:any;
DocumentExpirationDate:any;
PassportId:any;
IBAN:any;
TaxNumber:any;
SocialSecurityNumber:any;
SocialRegistryNumber:any;
SecondarySocialRegistryNumber:any;
FirstInsuranceDate:any;
UnemploymentCardNumber:any;
HasUnemploymentBenefit:any;
WorkExperience:any;
WorkExperienceMonths:any;
WorkExperienceDays:any;
BusinessPhone:any;
InternalPhone:any;
EmailBusiness:any;
Address:any;
UserAccount:any;
Citizenship:any;
Nationality:any;
static setAddress = ($this, value) => {
var oldValue = $this.Address;
$this.Address = value;
if (value != null) {
}
}
static setUserAccount = ($this, value) => {
var oldValue = $this.UserAccount;
$this.UserAccount = value;
if (value != null) {
}
}
static setCitizenship = ($this, value) => {
var oldValue = $this.Citizenship;
$this.Citizenship = value;
if (value != null) {
}
}
static setNationality = ($this, value) => {
var oldValue = $this.Nationality;
$this.Nationality = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}